import { ca } from '@cian/analytics';

export function trackShowAdvancedFiltersClick() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'popup_more_param_open',
  });
}
